import React from 'react';
import { string, arrayOf, object, bool, func } from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';
import FilterCollapsePanel from '../FilterCollapsePanel/FilterCollapsePanel';
import ListItemConnect from './ListItemConnect/ListItemConnect';
import './ToggleList.scss';

export default function ToggleList({
    className,
    label,
    items,
    attribute,
    openedByDefault,
    onFilterSelected,
}) {
    const intl = useIntl();
    return (
        <FilterCollapsePanel
            label={label}
            className={className}
            dataQa={attribute}
            openedByDefault={openedByDefault}
        >
            {items.map(item => (
                <ListItemConnect
                    className="toggle-list__checkbox"
                    key={`${label}_${item.order}`}
                    label={intl.formatMessage(
                        defineMessages(item.labelKey.label),
                    )}
                    attribute={item.attributeName}
                    value="true"
                    onFilterSelected={onFilterSelected}
                />
            ))}
        </FilterCollapsePanel>
    );
}

ToggleList.propTypes = {
    items: arrayOf(object).isRequired,
    label: string.isRequired,
    className: string,
    attribute: string.isRequired,
    openedByDefault: bool,
    onFilterSelected: func.isRequired,
};

ToggleList.defaultProps = {
    className: null,
    openedByDefault: true,
};
